import FormIncidencia from "./form";


export default function EditarIncidencia() {
    return (
        <FormIncidencia
            idIncidencia={localStorage.getItem("incEdit")}
        />
    )
}